import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CommonService } from '../common-service/common.service';


@Injectable()
export class BasicAuthInterceptor implements HttpInterceptor {
    refrestokencheck: boolean;
    constructor(
        private commonService: CommonService,
    ) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // add authorization header with basic auth credentials if available
        this.commonService.countryCode = localStorage.getItem('countryCode');
        this.commonService.userId = localStorage.getItem('userId');
        this.commonService.userRole = localStorage.getItem('userRoles');
        this.commonService.roleId   = localStorage.getItem('roleId');

        const AuthToken = localStorage.getItem('token')
        const currentTime : number = (new Date).getTime();
        const expirationTime : number = parseInt(localStorage.getItem('expirationTime'));

        const val = expirationTime - currentTime;
        var minutes = Math.floor(val / 60000);
        var seconds = ((val % 60000) / 1000).toFixed(0);

        if(minutes <= 10 && this.commonService.checkFlag) {
			this.commonService.checkFlag = false;
            this.commonService.refreshtoken().subscribe((resp)=>{
                let temp = resp['responseData'];
                localStorage.setItem('token', temp.refreshToken);
                localStorage.setItem("expirationTime", temp.expirationTime);
                this.commonService.checkFlag = true;
            },(err) => {
              this.commonService.checkFlag = true;
            });
        }

        if (AuthToken != null && AuthToken != undefined) {
            request = request.clone({
                setHeaders: {
                    Authorization: 'Bearer ' + AuthToken
                }
            });
        }
        return next.handle(request);
    }
}
